/* global axios */
import ApiClient from './ApiClient';

class MeetingsAPI extends ApiClient {
  constructor() {
    super('meetings', { accountScoped: true });
  }

 // get all items: /meetings/lists?start_date=2023-04-01&end_date=2025-04-31&user_id=74
 getAllMeetings(params={}) {
  return axios.get(`${this.url}/lists`,{
    params: {
      ...params
    }
  });
 }
 // get all items: /meetings/reports?start_date=2023-04-01&end_date=2025-04-31
 getMeetingReport(params={}) {
  return axios.get(`${this.url}/reports`,{
    params: {
      ...params
    }
  });
 }

 // get all items: /meetings/reports?start_date=2023-04-01&end_date=2025-04-31
 getMeetingReportByContact(params={}) {
  return axios.get(`${this.url}/meeting_report_by_contact`,{
    params: {
      ...params
    }
  });
 }

}

export default new MeetingsAPI();
